/**
* favoritesInit: inits the Favorites and eventLogger
*/
define('favoritesInit',[
  'Favorites',
  'eventLogger'
], (
  Favorites,
  EventLogger
) => {
  'use strict';

  const parameters = {
    logger: new EventLogger(),
    urlBase: ''
  };

  function init() {
    const favoritesObject = new Favorites(parameters);
    favoritesObject.init();
  }

  return {
    init
  };
});

